module.exports = __webpack_public_path__ + "img/shot_img20022501.184974cd.gif";